export default __webpack_public_path__ + "static/media/rus.08b75a69.svg";